module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('header', {
    staticClass: "fullscreen-element no-pad centered-text",
    attrs: {
      "id": "header-404"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 text-center"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n              Page not found."), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "router-link-container",
    attrs: {
      "to": "/"
    }
  }, [_c('link-button', {
    attrs: {
      "label": 'HOME'
    }
  })], 1)], 1)])])])]), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
    staticClass: "section-joined-bottom"
  }, [_c('text-ticker', {
    attrs: {
      "page": "home"
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "section-joined-top"
  }, [_c('footer-image')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-707574b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/404.vue
// module id = 149
// module chunks = 2